var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBilling({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m39,19.5c0,10.77-8.73,19.5-19.5,19.5S0,30.27,0,19.5,8.73,0,19.5,0s19.5,8.73,19.5,19.5Z",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.58,25.88v-.67,1.14c0,1.46-1.19,2.65-2.65,2.65h-9.77c-1.46,0-2.65-1.19-2.65-2.65v-13.7c0-1.46,1.19-2.65,2.65-2.65h9.77c1.46,0,2.65,1.19,2.65,2.65v1.01m-2.44-.27c-3.37,0-6.11,2.73-6.11,6.11s2.73,6.11,6.11,6.11,6.11-2.73,6.11-6.11-2.73-6.11-6.11-6.11Zm-2.88,6.44l1.5,1.71c.09.1.2.15.34.15.13,0,.25-.05.34-.15l3.25-3.69",
    fill: "none",
    stroke: "#624de3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilling);
export default __webpack_public_path__ + "static/media/billing.e71506f32cdd2a95f6234ed101477d55.svg";
export { ForwardRef as ReactComponent };